<template>
  <div>
    <app-spinner v-if="!page_loaded" />
    <template v-else>
      <app-cells>
        <div class="date-picker-wrapper">
          <VueCtkDateTimePicker
            id="date_picker_balance"
            class="custom-date-time-picker custom-date-time-picker--range"
            v-model="filter_dates"
            :custom-shortcuts="custom_shortcuts"
            @is-hidden="onIsHiddenPicker"
            format="YYYY-MM-DD"
            formatted="ll"
            label="Select dates"
            color="#77b017"
            button-color="#77b017"
            overlay
            no-header
            no-label
            locale="en"
            range
            noClearButton
          />
          <div v-if="date_picker_error" class="date-picker-wrapper__error">Choose an end date</div>
        </div>
        <app-input
          @input.native="onTransactionSearch"
          v-model="filter_search"
          class="input--300"
          type="search"
          placeholder="Search"
          name="search"
        />
        <app-filters
          v-model="filter_property"
          :filters="filter_property_options"
          name="filterType"
          @change="onChangeFilter"
        />
      </app-cells>
      <app-cells><h2 class="title">Rooms</h2></app-cells>
      <v-client-table
        :data="table_rooms.items"
        :columns="table_rooms.columns"
        :options="table_rooms.options"
        class="table-default"
        :class="{ 'table-default--loading': table_rooms_preloader }"
      >
        <template #h__user><div class="table-default__left">Waiter</div></template>
        <template #h__received_by><div class="table-default__left">Received by</div></template>
        <template #created="{ row }">{{ dateFormat(row.created_at) }}</template>
        <template #user="{ row }"><div class="table-default__left">{{ row.user }}</div></template>
        <template #number="{ row }">{{ row.number || '-' }}</template>
        <template #amount="{ row }">{{ amountFormat(row.order_amount) }} $</template>
        <template #tips="{ row }">{{ row.waiter_tip ? `${amountFormat(row.waiter_tip.amount)} $` : '-' }}</template>
        <template #received="{ row }">
          <label class="checkbox checkbox--table" :key="repaint_key">
            <input
              @change="onPatchReceived(row.id, {recieved: row.recieved}, 'fetchRoomsItems')"
              v-model="row.recieved"
              type="checkbox"
            />
            <span class="checkbox__checkmark"></span>
          </label>
        </template>
        <template #received_by="{ row }">
          <div class="table-default__left">
            <div v-if="row.recieved_by" class="table-default__controls">
              <div class="table-default__photo">
                <img
                  :src="getUserAvatar(row.recieved_by.crop.crop_url)" alt=""
                  v-tooltip="{ content: row.recieved_by.full_name, placement: 'top-end', offset: 10 }"
                >
              </div>
              {{ dateFormat(row.recieved_at) }}
            </div>
          </div>
        </template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPaginationRooms"
            v-if="pagination_rooms.pages > 1"
            v-model="pagination_rooms.page"
            :page-count="pagination_rooms.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination_rooms.count" :count="table_rooms.items.length" :page="pagination_rooms.page" />
      </app-cells>
      <app-cells><h2 class="title">Walk-in</h2></app-cells>
      <v-client-table
        :data="table_walk.items"
        :columns="table_walk.columns"
        :options="table_walk.options"
        class="table-default"
        :class="{ 'table-default--loading': table_walk_preloader }"
      >
        <template #h__user><div class="table-default__left">Waiter</div></template>
        <template #h__received_by><div class="table-default__left">Received by</div></template>
        <template #created="{ row }">{{ dateFormat(row.created_at) }}</template>
        <template #user="{ row }"><div class="table-default__left">{{ row.user }}</div></template>
        <template #number="{ row }">{{ row.number || '-' }}</template>
        <template #amount="{ row }">{{ amountFormat(row.order_amount) }} $</template>
        <template #tips="{ row }">{{ row.waiter_tip ? `${amountFormat(row.waiter_tip.amount)} $` : '-' }}</template>
        <template #received="{ row }">
          <label class="checkbox checkbox--table" :key="repaint_key">
            <input
              @change="onPatchReceived(row.id, {recieved: row.recieved}, 'fetchWalkItems')"
              v-model="row.recieved"
              type="checkbox"
            />
            <span class="checkbox__checkmark"></span>
          </label>
        </template>
        <template #received_by="{ row }">
          <div class="table-default__left">
            <div v-if="row.recieved_by" class="table-default__controls">
              <div class="table-default__photo">
                <img
                  :src="getUserAvatar(row.recieved_by.crop.crop_url)" alt=""
                  v-tooltip="{ content: row.recieved_by.full_name, placement: 'top-end', offset: 10 }"
                >
              </div>
              {{ dateFormat(row.recieved_at) }}
            </div>
          </div>
        </template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPaginationWalk"
            v-if="pagination_walk.pages > 1"
            v-model="pagination_walk.page"
            :page-count="pagination_walk.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination_walk.count" :count="table_walk.items.length" :page="pagination_walk.page" />
      </app-cells>
    </template>
  </div>
</template>

<script>
import { getHotelManagementRestaurantReceipts, patchHotelManagementRestaurantReceipts } from '@/http'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import { format, parseISO } from 'date-fns'
import debounce from 'lodash/debounce'

export default {
  name: 'HotelManagementRestaurantReceiptsGuests',
  components: {VueCtkDateTimePicker},
  data() {
    return {
      page_loaded: false,
      filter_dates: {},
      date_picker_error: false,
      filter_search: '',
      filter_property: 'false',
      filter_property_options: [
        { value: 'false', label: 'Pending' },
        { value: 'true', label: 'Received' },
        { value: '', label: 'All' },
      ],
      custom_shortcuts: [
        { key: 'last3Days', label: 'Last 3 days', value: 3 },
        { key: 'last7Days', label: 'Last 7 days', value: 7 },
        { key: 'last14Days', label: 'Last 14 days', value: 14 },
      ],
      table_rooms: {
        items: [],
        columns: [
          'id',
          'created',
          'user',
          'number',
          'table',
          'amount',
          'tips',
          'received',
          'received_by',
        ],
        options: {
          headings: {
            'id': 'ID',
            'created': 'Created',
            'user': 'Waiter',
            'number': 'Number',
            'table': 'Room',
            'amount': 'Amount',
            'tips': 'Tips',
            'received': 'Received',
            'received_by': 'Received by',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_rooms: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_rooms_preloader: false,
      table_walk: {
        items: [],
        columns: [
          'id',
          'created',
          'user',
          'number',
          'table',
          'amount',
          'tips',
          'received',
          'received_by',
        ],
        options: {
          headings: {
            'id': 'ID',
            'created': 'Created',
            'user': 'Waiter',
            'number': 'Number',
            'table': 'Table',
            'amount': 'Amount',
            'tips': 'Tips',
            'received': 'Received',
            'received_by': 'Received by',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_walk: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_walk_preloader: false,
      repaint_key: 1,
    }
  },
  created() {
    Promise.all([this.fetchRoomsItems(), this.fetchWalkItems()])
      .then(() => { this.page_loaded = true })
  },
  methods: {
    async fetchRoomsItems() {
      this.table_rooms_preloader = true
      const response = await getHotelManagementRestaurantReceipts({
        page: this.pagination_rooms.page,
        page_size: 20,
        search: this.filter_search,
        recieved: this.filter_property,
        created_at__gte: this.filter_dates?.start,
        created_at__lte: this.filter_dates?.end,
        section: 'Rooms'
      })
      this.table_rooms.items = response.data.results
      this.pagination_rooms.pages = response.data.pages
      this.pagination_rooms.count = response.data.count
      this.repaint_key += 1
      this.table_rooms_preloader = false
    },
    async fetchWalkItems() {
      this.table_walk_preloader = true
      const response = await getHotelManagementRestaurantReceipts({
        page: this.pagination_walk.page,
        page_size: 20,
        search: this.filter_search,
        recieved: this.filter_property,
        created_at__gte: this.filter_dates?.start,
        created_at__lte: this.filter_dates?.end,
        section: 'Walk-in'
      })
      this.table_walk.items = response.data.results
      this.pagination_walk.pages = response.data.pages
      this.pagination_walk.count = response.data.count
      this.repaint_key += 1
      this.table_walk_preloader = false
    },
    onClickPaginationRooms(page) {
      this.pagination_rooms.page = page
      this.fetchRoomsItems()
    },
    onClickPaginationWalk(page) {
      this.pagination_walk.page = page
      this.fetchWalkItems()
    },
    onPatchReceived(id, data, action) {
      patchHotelManagementRestaurantReceipts(id, data)
        .then(() => {
          this[action]()
        })
    },
    fetchTables() {
      this.fetchRoomsItems()
      this.fetchWalkItems()
    },
    onChangeFilter() {
      this.filter_search = ''
      this.pagination_rooms.page = 1
      this.pagination_walk.page = 1
      this.fetchTables()
    },
    onIsHiddenPicker() {
      if (this.filter_dates?.start && this.filter_dates?.end) {
        this.date_picker_error = false
        this.fetchTables()
      } else this.date_picker_error = true
    },
    amountFormat(amount) {
      return new Intl.NumberFormat('ru-RU').format(amount)
    },
    dateFormat(date) {
      return date ? format(parseISO(date), 'dd MMM yyyy HH:mm') : '-'
    },
    getUserAvatar(crop_url) {
      if (crop_url) return crop_url
      return require('@/assets/img/temp/avatar-slug.jpg')
    },
    onTransactionSearch() {
      this.searchTransaction(this)
    },
    searchTransaction: debounce(vm => {
      vm.pagination_rooms.page = 1
      vm.pagination_walk.page = 1
      vm.fetchTables()
    }, 350),
  }
}
</script>
